import React from 'react'
import { observer } from 'mobx-react'
import classnames from 'classnames'
import IconMarker from './IconMarker'

// Represents an interactive drawing handle which
// can be active or inactive, and normal (closed circle)
// or "open" (outline of a circle). An open drawing handle is used
// to represent the first point of a shape which must be clicked
// again to close the shape.
const DrawingHandle = ({
  position, icon, open, inactive, last, ...other
}) => (
  position
    ? (
      <IconMarker
        position={position}
        icon={
          open
            ? (inactive ? 'draw-handle-open-inactive' : 'draw-handle-open')
            : 'draw-handle'
        }
        className={classnames({
          'leaflet-interactive': true,
          focused: true,
          last,
          'draw-handle': true,
          'draw-handle-inactive': inactive,
          'draw-handle-open': open
        })}
        fillOpacity='1'
        {...other}
      />
      )
    : null
)

export default observer(DrawingHandle)
